import React from 'react'
import { NavLink } from 'react-router-dom'
import home from '../assets/icon/home.svg'
import OurCommunity from '../assets/icon/community.svg'
import AboutUs from '../assets/icon/about-us.svg'
import FAQ from '../assets/icon/faq.svg'

function NFTFooter() {
  return (
    <div className='nft-bootm-menu'>
        <NavLink to="/app/home">
        <div className='nftMenuItem'>
            <img src={home} alt="Home" srcset="" />
            <h2>Home</h2>
        </div>
        </NavLink>
        <NavLink to="/app/aboutus">
        <div className='nftMenuItem'>
            <img src={AboutUs} alt="About Us" srcset="" />
            <h2>About Us</h2>
        </div>
        </NavLink>
        <NavLink to="/app/ourcommunity">
        <div className='nftMenuItem'>
            <img src={OurCommunity} alt="Our Comm" srcset="" />
            <h2>Our Community</h2>
        </div>
        </NavLink>
        <NavLink to="/app/faq">
        <div className='nftMenuItem'>
            <img src={FAQ} alt="FAQ" srcset="" />
            <h2>FAQ</h2>
        </div>
        </NavLink>
    </div>
  )
}

export default NFTFooter